import React from 'react';

import './styles/collections-row.scss';
import KebabIcon from '../../../images/icons/icon-kebab.svg';

const CollectionRow = ({ row }) => {
  const { status, name, type, merchants, products, selected } = row;
  return (
    <div className="collection-item">
      <img className="dots-icon" src={KebabIcon} alt="info" />
      <span className={`checkbox ${selected ? 'selected' : ''}`} />
      <div className="status">{status}</div>
      <div className="collection-details">
        <div className="collection-name">{name}</div>
        <div className="campaign" />
      </div>
      <div className="collection-type">{type}</div>
      <div className="merchants">{merchants}</div>
      <div className="products">{products}</div>
    </div>
  );
};

export default CollectionRow;
